import { APP_BASE_HREF } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ResponseHandler } from '@app/_core/helper/ResponseHandler';
import { Utils } from '@app/_core/helper/Utils';
import { AppService } from '@app/_core/services/app.service';
import { AuditorService } from '@app/_core/services/auditor.service';
import { ManagerService } from '@app/_core/services/manager.service';
import { SecurityService } from '@app/_core/services/security.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { FilterDialogComponent } from '@app/pages/common/filter-dialog/filter-dialog.component';
import { InteractionAuditComponent } from '@app/pages/common/interaction-audit/interaction-audit.component';
import { ShowHideDialogComponent } from '@app/pages/common/show-hide-dialog/show-hide-dialog.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { TableLazyLoadEvent } from 'primeng/table';
import { catchError, EMPTY, forkJoin, map, of } from 'rxjs';

@Component({
  selector: 'app-audit-details',
  templateUrl: './audit-details.component.html',
  styleUrls: ['./audit-details.component.scss'],
})
export class AuditDetailsComponent implements OnInit, OnDestroy{
  currentMenu: any = {};
  action = '';
  innerHeight = 10;

  totalRecords: number;
  loading: boolean;
  modalRef?: BsModalRef;

  auditList: any = [];
  localStorageName = 'AuditsColumnDisplaySettings';
  headercount: any = { shown: 0, hidden: 0 };

  /*globalfilter*/
  findOptions: any = [
    { label: 'Agent First Name', value: 'FirstName' },
    { label: 'Agent Last Name', value: 'LastName' },
    { label: 'Audit ID', value: 'SurveyID' },
    { label: 'Interaction ID', value: 'InteractionID' },
  ];
  getAuditsTimeout: any;
  constructor(
    private utils: Utils,
    private auditorService: AuditorService,
    private securityService: SecurityService,
    private webStorage: WebStorageService,
    private router: Router,
    private modalService: BsModalService,
    private appService: AppService,
    private route: ActivatedRoute,
    private managerService: ManagerService,
    @Inject(APP_BASE_HREF) public baseHref: string
  ) {}

  rowOffset = 0;
  rowCount = 50;
  searchField: any = '';
  searchValue: any = '';
  filterDict: any = null;
  sortColumn = 'Date';
  sortDescend = true;
  filterOptionRequestColumn = '';
  fromDate: Date = new Date();
  toDate: Date = new Date();
  pl: any = {};

  cols: any = [
    { name: 'ID', label: 'ID', type: 'numeric' },
    { name: 'Agent', label: 'Agent', showFilter: true },
    { name: 'Group', label: 'Group', showFilter: true },
    { name: 'Manager', label: 'Manager', showFilter: true, format: 'name' },
    { name: 'Auditor', label: 'Auditor', showFilter: true, format: 'name' },
    { name: 'Status', label: 'Status', showFilter: true },
    { name: 'Score', label: 'Score', showFilter: false },
    { name: 'InteractionID', label: 'Interaction ID', showFilter: false },
    { name: 'SurveyForm', label: 'Survey Form', showFilter: true },
    { name: 'Date', label: 'Date', type: 'date', showFilter: false },
  ];

  ngOnInit(): void {
    this.fromDate.setFullYear(this.fromDate.getFullYear() - 1);
    this.appService.currentMenu.subscribe((val: boolean) => {
      this.currentMenu = val;
      this.action = this.currentMenu.name;
    });

    this.searchField = this.findOptions[0];
    this.initializeColumnHeader();
    this.loadAudits();

    this.route.params.subscribe((params: any) => {
     // console.log(params);
      //  alert(params.id)
      //alert("insude")
      forkJoin({
        interactionDetails: of(this.loadInteractionDetails(params.id)),
        surveyDetails: of(this.loadGetSurveysGroupedByDefinition(params.id)),
      }).subscribe(({ interactionDetails, surveyDetails }) => {
        //alert(interactionDetails);
        // alert(surveyDetails)
        const isInteractionDetailResponseValid = ResponseHandler.processResponse(
          interactionDetails,
          'InteractionDetails'
        );
        const isSurveysGroupedByDefinitionResponseValid = ResponseHandler.processResponse(
          surveyDetails,
          'GetSurveysGroupedByDefinition'
        );
        if (isInteractionDetailResponseValid && isSurveysGroupedByDefinitionResponseValid) {
          const initialState = {
            interactionDetails: interactionDetails,
            surveyDetails: surveyDetails,
          };

          const config: ModalOptions = {
            class: 'interaction-audit',
            initialState,
          };
          this.modalRef = this.modalService.show(InteractionAuditComponent, config);
          this.modalRef.content.event.subscribe((result: any) => {
            this.cols = result.data;
          });
        }
      }),
        catchError(error => {
          this.loading = false;
          return EMPTY;
        });

      //this.loadSkillAgents(params.id)
    });
  }

  applySelectedDateRange() {
    this.loadAudits();
  }
  resetDateRange() {
    this.toDate = new Date();
    this.fromDate = new Date();
    this.fromDate.setFullYear(this.fromDate.getFullYear() - 1);
    this.loadAudits();
  }
  initializeColumnHeader() {
    const localCol = this.webStorage.getItemFromLocalStorage(this.localStorageName);
    if (localCol != null) {
      this.cols = localCol;
    } else {
      for (const col of this.cols) {
        if (col.name == this.sortColumn) {
          if (this.sortDescend) {
            col.isAsc = false;
          } else {
            col.isAsc = true;
          }
        } else {
          delete col.isAsc;
        }
        col.hide = false;
      }
      this.webStorage.setItemInLocalStorage(this.localStorageName, this.cols);
    }
    this.getColumnCount();
  }

  getColumnCount() {
    let shown = 0;
    let hidden = 0;
    for (const header of this.cols) {
      if (header.hide) {
        hidden++;
      } else {
        shown++;
      }
    }
    this.headercount.shown = shown;
    this.headercount.hidden = hidden;
  }

  /*globalFilter*/
  clearSearchBox() {
    this.searchValue = '';
    delete this.pl['searchField'];
    this.loadAudits();
  }
  applyFilterByField() {
    this.loadAudits();
  }

  /*column filter* starts here*/
  toggleCustomColumnFilter(colName: string) {
    this.filterOptionRequestColumn = colName;
    this.loadAudits();
  }

  showColumnFilterModal(colName: string) {
    const initialState = {
      cols: this.cols,
      colName: colName,
    };

    const config: ModalOptions = { class: 'task-menu', backdrop: 'static', initialState };
    this.modalRef = this.modalService.show(FilterDialogComponent, config);
    this.modalRef.content.event.subscribe((result: any) => {
      this.cols = result.data;
      this.applyColumnFilters();
    });
  }

  /*column level filter*/
  applyColumnFilters() {
    //apply column filter here and assign to dataTodisplay
    this.filterOptionRequestColumn = '';
    for (const colData of this.cols) {
      const filterVals: string[] = [];
      if (colData.filterVals && colData.filterVals.length > 0) {
        for (const val of colData.filterVals) {
          if (val.checked) {
            filterVals.push(val.name.toString());
          }
        }
        this.filterDict = [];
        this.filterDict.push({ Key: colData.name, Value: filterVals });
      }
    }
    this.loadAudits();
  }

  showHideColumns() {
    const initialState = {
      headerNames: this.cols,
      localStorageName: this.localStorageName,
    };

    const config: ModalOptions = { class: 'task-menu', backdrop: 'static', initialState };

    this.modalRef = this.modalService.show(ShowHideDialogComponent, config);

    this.modalRef.content.event.subscribe((result: any) => {
      this.initializeColumnHeader();
    });
  }
  sortByColumn(colName: string) {
    this.sortColumn = colName;
    this.sortDescend = !this.sortDescend;
    this.cols = this.utils.sortByFieldInServer(colName, this.cols);
    this.webStorage.setItemInLocalStorage(this.localStorageName, this.cols);
    this.loadAudits();
  }

  /*onRowSelect(event: any) {
    alert('test' + event.data.ID)
    this.router.navigateByUrl(this.router.url + "/Details/" + event.data.ID)
  }*/

  loadGetAudits(event: TableLazyLoadEvent) {
    this.loading = true;
    this.pl.rowOffset = event.first;
    this.pl.rowCount = event.rows;
    this.getAuditsTimeout = setTimeout(
      () => {
        //load data of required page
        this.auditorService
          .GetAudits(this.pl)
          .pipe(
            map((data: any) => {
              const isValid = ResponseHandler.processResponse(data, 'GetAudits');
              if (isValid) {
                this.auditList = data.Response.Data;
                this.totalRecords = this.auditList.TotalItems;
                this.loading = false;

                //trigger change detection
                event.forceUpdate();
                this.setInnerWidthHeightParameters();
              } else {
              }
            }),
            catchError(error => {
              this.loading = false;
              return EMPTY;
            })
          )
          .subscribe();
      },
      Math.random() * 1000 + 250
    );
  }
  loadAudits() {
    this.pl = {
      rowOffset: 0,
      rowCount: 10,
      searchValue: this.searchValue,
      searchField: this.searchField.value,
      filterDict: this.filterDict,
      sortColumn: this.sortColumn,
      sortDescend: this.sortDescend,
      filter: {
        FromDate: new Date(this.fromDate).getTime(),
        ToDate: new Date(this.toDate).getTime(),
      },
    };
    if (this.filterOptionRequestColumn != '') {
      this.pl.filterOptionRequestColumn = this.filterOptionRequestColumn;
    } else {
      delete this.pl['filterOptionRequestColumn'];
    }
    this.loading = true;
    this.auditorService
      .GetAudits(this.pl)
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'GetAudits');
          if (isValid) {
            if (this.pl.filterOptionRequestColumn) {
              data = {
                Response: {
                  Data: [
                    'Antonio Rubin',
                    'Srinivas Ramdas',
                    'Himangshu Das (Manager Console)',
                    'Shubham Kumar',
                    'Arun Kumar',
                    'Ashish Chaudhary',
                    'Vinayaka Magaji',
                    'Sadhesh Kumar',
                    'Ranjith Kumar Shanmugam',
                    'Divya Rajendrian',
                    'Mona Bhanderia',
                    'Manoj Gupta',
                  ],
                  Status: 1,
                  Message: null,
                },
                Status: 1,
                Message: null,
              };

              for (const col of this.cols) {
                if (col.name == this.pl.filterOptionRequestColumn) {
                  if (col.filterVals) {
                  } else {
                    const unique = data.Response.Data; //[...new Set(this.filteredData.map((item: any) => item[colName]))];
                    const filterData: any = [];
                    for (const val of unique) {
                      filterData.push({
                        name: new String(val),
                        checked: false,
                      });
                    }
                    col.filterVals = filterData;
                  }
                } else {
                }
              }
              this.showColumnFilterModal(this.pl.filterOptionRequestColumn);
              delete this.pl['filterOptionRequestColumn'];
            } else {
              this.auditList = data.Response.Data;
              this.setInnerWidthHeightParameters();
            }
            this.loading = false;
          }
        }),
        catchError(error => {
          this.loading = false;
          return EMPTY;
        })
      )
      .subscribe();
  }

  setInnerWidthHeightParameters() {
    this.innerHeight = window.innerHeight * 0.07;
  }
  loadInteractionDetails(id: number) {
    return this.auditorService.GetInteractionsDetailById(id);

    /*.pipe(
      map((data: any) => {
        var isValid = ResponseHandler.processResponse(data, "GetInteractionsDetailById");
        if (isValid) {

          return data;



          // this.queueDetail = data.Response.Data;
          // this.title = "Queue " + this.queueDetail.ID + " - " + this.queueDetail.Name;
          // this.details = { ID: this.queueDetail.ID, owner: 'queue', object: 'agent', service: this.managerService, method: 'GetQueueAgents', priorities: false, persistence: false, roles: false, disable: !this.securityService.validateGrant("ManageAssignments") }


        }
        else {

        }
      }),
      catchError((error) => {

        return EMPTY;
      })
    )
      .subscribe();
  }*/
  }

  loadGetSurveysGroupedByDefinition(id: number) {
    return this.auditorService.GetSurveysGroupedByDefinition(id);
  }

  ngOnDestroy(): void {
    this.getAuditsTimeout && clearTimeout(this.getAuditsTimeout);
  }
}
